import * as cpList from '../services/cpList';

export default {
  namespace: 'cpList',

  state: {
    // userInfo: null,
    // getMemberList: null,
    // addMember: null,
  },

  effects: {
    *getCpList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(cpList.getCpList, {
        ...values,
        rejectType: values.rejectType ?? 'THIRD_PARTY_COUPON',
      });
      yield put({
        type: 'save',
        payload: {
          cpList: response?.data,
          pages: response?.data.pages,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *getCpListHasNext({ payload: { values }, callback }, { call, put }) {
      const response = yield call(cpList.getCpList, values);
      yield put({
        type: 'save',
        payload: {
          cpListHasNext: response.data?.hasNext,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *getSearchCpList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(cpList.getSearchCpList, values);
      yield put({
        type: 'save',
        payload: {
          cpSearchList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //获取太阳码的buffer
    *getUnlimited({ payload: { values }, callback }, { call, put }) {
      const response = yield call(cpList.getUnlimited, values);
      yield put({
        type: 'save',
        payload: {
          getUnlimited: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *clearCpList({}, { put }) {
      yield put({
        type: 'save',
        payload: {
          cpList: [],
          cpSearchList: [],
        },
      });
    },

    // *addMember({ payload: { values }, callback }, { call, put }) {
    //   const response = yield call(cpList.addMember, values);
    //   if (response) {
    //     if (callback && typeof callback === 'function') {
    //       return callback(response);
    //     }
    //   }
    //   yield put({
    //     type: 'save',
    //     payload: {
    //       addMember: response,
    //     },
    //   });
    // },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
